import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { IWorkTimeType } from '../interface/workTimes';

interface IFetchWorkTimeTypeById {
  id?: string;
}
export const useFetchWorkTimeTypeById = (params: IFetchWorkTimeTypeById) => {
  const { id, ...queryParams } = params;
  const queryString = Object.keys(queryParams)?.length
    ? toQueryString(queryParams as QueryParamObject)
    : null;
  const matterUrl = `${API_URLS.WORK_TIME_TYPES}/${id}`;
  const url = queryString ? `${matterUrl}?${queryString}` : matterUrl;
  const query = useQuery<IWorkTimeType, Error>({
    queryKey: ['worktime-type', id],
    queryFn: async () => {
      const response = await get(url);
      return response;
    },
    enabled: !!id,
  });

  return query;
};
